var React = require('react');

function MoonGeneric1 (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("clipPath",{"id":"generic1"},React.createElement("path",{"d":"\n        M 40,21.7\n        A 30,30 0 11 40,78.3\n        A 30,30 1 00 40,21.7\n      "}))),React.createElement("rect",{"width":"100%","height":"100%","fill":"#080808","key":1}),React.createElement("circle",{"cx":"50","cy":"50","r":"30","id":"the-full-moon","className":"a-full-moon","stroke":"#FFF","fill":"#FED","clipPath":"url(#generic1)","key":2})]);
}

MoonGeneric1.defaultProps = {"viewBox":"0 0 100 100","className":"a-class-added","title":"a-title-added"};

module.exports = MoonGeneric1;

MoonGeneric1.default = MoonGeneric1;
